const VerifiedTooltip = () => {
	return (
		<div className="w-[255px] rounded-[5px] overflow-hidden shadow-md">
			<div className="bg-[#E5F0FF] dark:bg-[#374151] px-[12px] py-[6px]">
				<p className="font-inter text-[15px] font-[600] text-[#004FC4] dark:text-white">Verified Account</p>
			</div>
			<div className="max-w-full px-[12px] py-[8px] font-inter bg-white dark:bg-slate-600 text-gray-700 dark:text-gray-100">
				<p className="text-left">
					Recruiters give more priority to <br /> verified accounts{' '}
				</p>
			</div>
		</div>
	);
};

export default VerifiedTooltip;
